import Vue from "vue";
export const bus = new Vue();
// export const SUCEESSS_POPUP = "successPop";
// export const FAIL_GIFT_POPUP = "failGiftPop";
// export const FAIL_CHECK_POPUP = "failCheckPop";
let userAgent = window.navigator.userAgent;
let ua = userAgent.toLowerCase();
export const CURRENCY = "TWD";

export let isAndroid = function() {
  return ua.indexOf("android") > -1;
};
export let isIOS = function() {
  // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  return ua.indexOf("iphone") > -1;
};
export let isWinPhone = function() {
  return !!navigator.userAgent.match(/Windows Phone/i);
};
export let isIpad = function() {
  return ua.indexOf("iPad") > -1;
};
export let isPhone = function() {
  return isAndroid() || isIOS() || isWinPhone() || isIpad();
};

export let getCurrentDay = function() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  var day = date.getDate();
  day = day > 9 ? day : "0" + day;
  return year + "/" + month + "/" + day;
};

export let generateFbHref = function(gameId) {
  return (
    "https://mfbapps.gm99.com/fb_share_resource/get_ingame_resource/game/" +
    gameId +
    "/achievement/9999/"
  );
};

export let horizontalScreen = function() {
  return /90/.test(window.orientation);
};

export let isFBApp = function() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
};

export const getLclStorageItem = function(name) {
  var res = null;
  if ("undefined" != typeof window.localStorage) {
    res = JSON.parse(window.localStorage.getItem(name));
    return res;
  }
  return res;
};
export const setLclStorageItem = function(name, val) {
  if (window.localStorage) {
    return window.localStorage.setItem(name, JSON.stringify(val));
  }
};
export const setCookie = function(name, value, time) {
  var foreverTime = new Date();
  foreverTime.setFullYear(foreverTime.getFullYear() + 3000);
  document.cookie = `${name}=${value};domain=gm99.com;expires=${time ||
    foreverTime.toGMTString()}`;
};
export const getCookie = function(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
};



// WEBPACK FOOTER //
// ./src/utile/index.js